import { Grid, TextField, Checkbox, List } from '@mui/material';

export default function ProductTableInfoContainer({ edit = false, productData, detailsProp, scheduled, setScheduled }) {
    /******************
          CONST
      *******************/
    return (
        <div className='col-12'>
            <List className='col-12 overflow-auto' id={"product-specs-info"}>
                {detailsProp.map((field, index) =>
                    <table className="w-full text-left table my-3 col-12" key={field.reference}>
                        <thead>
                            <tr>
                                <th className='p-2 text-center' colSpan={3}>{field.title}</th>
                            </tr>
                            <tr>
                                <th className='p-2 text-center col-3'>Caraterística</th>
                                <th className='p-2 text-center'>Información</th>
                                <th className='p-2 text-center col-3'>Pág.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {field.rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td className='p-2'>{row.title}</td>
                                    <td className='p-2'>{productData[field.reference + "_" + row.reference + "_info"]}</td>
                                    <td className='p-2'>{productData[field.reference + "_" + row.reference + "_page"]}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </List>
        </div>
    )
}